import React, { useState, useEffect, useRef } from "react";
import HeaderLogo from "../../../assets/images/EconSignLogo.png";
import "./Header.scss";
import { Link } from "react-router-dom";

// Icons
import {
  FaLaptopCode,
  FaGlobe,
  FaServer,
  FaMobileAlt,
  FaPaintBrush,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [desktopServicesOpen, setDesktopServicesOpen] = useState(false);

  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [mobileOpen]);

  const closeSidebar = () => {
    setMobileOpen(false);
    setMobileServicesOpen(false);
  };

  const toggleMobile = () => {
    setMobileOpen((prev) => !prev);
    if (mobileOpen) setMobileServicesOpen(false);
  };

  const navItems = [
    { name: "Home", to: "/" },
    { name: "Portfolios", to: "/portfolios" },
    { name: "About Us", to: "/about-us" },
    { name: "Contact Us", to: "/contact-us" },
  ];

  const servicesMenu = [
    { name: "Software Development", to: "/software-development", icon: <FaServer /> },
    { name: "Web Development", to: "/web-development", icon: <FaGlobe /> },
    { name: "Full Stack Development", to: "/fullstack-development", icon: <FaLaptopCode /> },
    { name: "App Development", to: "/app-development", icon: <FaMobileAlt /> },
    { name: "UI/UX Design", to: "/uiux-development", icon: <FaPaintBrush /> },
  ];

  const handleServicesMouseEnter = () => {
    if (window.innerWidth <= 768) return;
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setDesktopServicesOpen(true);
  };

  const handleServicesMouseLeave = () => {
    if (window.innerWidth <= 768) return;
    hoverTimeoutRef.current = setTimeout(() => {
      setDesktopServicesOpen(false);
    }, 220);
  };

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : "transparent"}`}>
        <div className="container-header">
          <div className="navbar-inner">
            <Link to="/" className="logo">
              <img src={HeaderLogo} alt="EconSign Logo" className="econsign-logo" />
            </Link>

            <nav className="nav-links">
              {/* 👉 1. Home aur Portfolios pehle dikhenge */}
              {navItems.slice(0, 2).map((item) => (
                <Link key={item.name} to={item.to}>{item.name}</Link>
              ))}

              {/* 👉 2. Ab Services Dropdown Portfolio ke baad aayega */}
              <div
                className={`services-dropdown ${desktopServicesOpen ? "open" : ""}`}
                onMouseEnter={handleServicesMouseEnter}
                onMouseLeave={handleServicesMouseLeave}
              >
                <button className="services-btn">
                  Services <span className="chev"><FaChevronDown /></span>
                </button>
                <div className="services-panel">
                  <ul>
                    {servicesMenu.map((s) => (
                      <li key={s.name}>
                        <Link to={s.to} onClick={() => setDesktopServicesOpen(false)}>
                          <span className="svc-icon">{s.icon}</span>
                          <span className="svc-text">{s.name}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* 👉 3. Baki ke items: About Us aur Contact Us */}
              {navItems.slice(2).map((item) => (
                <Link key={item.name} to={item.to}>{item.name}</Link>
              ))}
            </nav>

            <button className={`mobile-toggle ${mobileOpen ? "open" : ""}`} onClick={toggleMobile}>
              <span className="hamburger-line line1"></span>
              <span className="hamburger-line line2"></span>
              <span className="hamburger-line line3"></span>
            </button>
          </div>
        </div>
      </header>

      <div className={`sidebar-overlay ${mobileOpen ? "active" : ""}`} onClick={closeSidebar} />

      {/* SIDEBAR MOBILE */}
      <div className={`sidebar ${mobileOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-top">
            <Link to="/" onClick={closeSidebar}>
              <img src={HeaderLogo} alt="EconSign Logo" className="sidebar-logo-img" />
            </Link>
            <button className="sidebar-close" onClick={closeSidebar}><FaTimes /></button>
          </div>
        </div>

        <nav className="sidebar-nav">
          {/* 👉 Sidebar mein bhi Portfolio ke baad Services */}
          {navItems.slice(0, 2).map((item) => (
            <Link key={item.name} to={item.to} onClick={closeSidebar} className="sidebar-link">
              {item.name}
            </Link>
          ))}

          <div className="sidebar-accordion">
            <button className="sidebar-accordion-toggle" onClick={() => setMobileServicesOpen((p) => !p)}>
              Services {mobileServicesOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            <div className={`sidebar-accordion-panel ${mobileServicesOpen ? "open" : ""}`}>
              <ul>
                {servicesMenu.map((s) => (
                  <li key={s.name}>
                    <Link to={s.to} onClick={closeSidebar} className="sidebar-svc-link">
                      <span className="svc-icon">{s.icon}</span>
                      <span className="svc-text">{s.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {navItems.slice(2).map((item) => (
            <Link key={item.name} to={item.to} onClick={closeSidebar} className="sidebar-link">
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Header;